var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:{'alert alert-address':true, 'alert-address-bold': _vm.bold},attrs:{"id":"alertPanel","role":"alert"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }